export default {
  FIRST_AMERICAN: 'FA',
  STRIPE: 'STRIPE',
  BRAINTREE: 'BRAINTREE',
  FA_BRAINTREE: 'FA_BRAINTREE',
}
